export enum UpdateUserResult {
  Error,
  Success,
  UserNotFound,
  DataIssue
};
